import PropTypes from 'prop-types';
import { Text } from './Text';

const buildSimpleList = (elements, key) => {
  const list = [];
  // eslint-disable-next-line no-unused-vars,no-restricted-syntax
  for (const element of elements) {
    if (typeof element === 'string') {
      list.push(element);
    } else if (typeof element === 'object') {
      if (!key) {
        console.error(
          'Value provided for `SimpleList` contains objects, but no key provided.',
        );
        list.push(null);
      } else {
        list.push(element[key]);
      }
    }
  }
  return list;
};

export const SimpleList = (props, customKey) => {
  let value;
  if (Array.isArray(props)) {
    value = buildSimpleList(props, customKey);
  } else if (Array.isArray(props.cell.value)) {
    value = buildSimpleList(props.cell.value, customKey);
  } else {
    // eslint-disable-next-line no-console
    console.error(
      'Value provided for `SimpleList` cell component is not accepted',
    );
  }

  return Text(value.join(', '));
};

SimpleList.propTypes = {
  cell: PropTypes.object,
};
